import MessageList from '@/data/message/view/MessageList.vue'
import Message from '@/data/message/view/Message.vue'
import MessageExportableList from '@/data/message/view/message-exportable-list.vue'

const list = {
  path: '/message',
  name: 'message-list',
  component: MessageList
}
const detail = {
  path: '/message/:id(\\d+)',
  name: 'message',
  component: Message
}

const list2 = {
  path: '/message-exportable',
  name: 'message-exportable-list',
  component: MessageExportableList
}

export default [list, detail, list2]
